export enum AutoCompleteTypeEnum {
  Users,
  UsersAndTeamsExceptFromOtherDepartment,
  UsersAndTeamsExceptFromOtherAndCostControlDepartment = 2
}
